import { BaseSyntheticEvent, MutableRefObject, useEffect } from 'react';

export function useOutsideClick<T extends HTMLDivElement>(
	ref: MutableRefObject<T | null>,
	callback: () => void
) {
	useEffect(() => {
		function handleClickOutside(event: BaseSyntheticEvent) {
			if (ref.current && !ref.current.contains(event.target)) {
				if (!callback) {
					// eslint-disable-next-line no-console
					console.warn('You use useOutsideClick with empty callback');
					return;
				}

				callback();
			}
		}

		document.addEventListener(
			'mousedown',
			handleClickOutside as () => EventListenerOrEventListenerObject
		);
		return () => {
			document.removeEventListener(
				'mousedown',
				handleClickOutside as () => EventListenerOrEventListenerObject
			);
		};
	}, [ref]);
}
